import { pipe } from 'fp-ts/lib/function';
import { getOrElseW, tryCatch } from 'fp-ts/lib/Option';
import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';

export function useCountryName() {
  const { locale } = useRouter();
  const regionNames = useMemo(
    () =>
      new Intl.DisplayNames([locale || ''], { type: 'region', style: 'short' }),
    [locale]
  );

  return useCallback(
    (countryCode: string) =>
      pipe(
        tryCatch(() => regionNames.of(countryCode)),
        getOrElseW(() => undefined)
      ),
    [regionNames]
  );
}
